import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { TimerAndTaskComponent } from './timer-and-task/timer-and-task.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {BlogComponent} from './blog/blog.component';
import {FeedbackComponent} from './feedback/feedback.component';
import {StatisticsComponent} from './statistics/statistics.component';
import {SettingComponent} from './setting/setting.component';
import {MenuComponent} from './menu/menu.component';
import {ForDebugComponent} from './for-debug/for-debug.component';
import {LoginComponent} from './auth/login/login.component';
import {ProfileComponent} from './profile/profile.component';
import {RegisterComponent} from './auth/register/register.component';
import {VerifyComponent} from './auth/verify/verify.component';
import {PreventLoginAccess} from './preventLoginAccess';
import {EditProfileComponent} from './edit-profile/edit-profile.component';
import {AppComponent} from './app.component';
import {PasswordComponent} from './auth/password/password.component';
import {ForgetPassComponent} from './auth/forget-pass/forget-pass.component';
import {MyChartComponent} from './my-chart/my-chart.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {CallbackComponent} from './callback/callback.component';
import {PricingComponent} from './pricing/pricing.component';
import {ReminderComponent} from './reminder/reminder.component';
import {LoginAsComponent} from './login-as/login-as.component';
import {ArchivesComponent} from './reminder/archives/archives.component';
import {PromptComponentComponent} from './prompt-component/prompt-component.component';
import {PaymentComponent} from './payment/payment.component';
import {TodolistComponent} from './dialogs/todolist/todolist.component';

const routes: Routes = [
  {path: '' , component: TimerAndTaskComponent},
  {path: 'feedback' , component: FeedbackComponent},
  {path: 'Statistics' , component: StatisticsComponent},
  {path: 'setting' , component: SettingComponent},
  {path: 'menu' , component: MenuComponent},
  {path: 'for' , component: ForDebugComponent},
  {path: 'login' , component: LoginComponent},
  {path: 'register' , component: RegisterComponent},
  {path: 'profile', component: ProfileComponent, canActivate: [PreventLoginAccess]},
  {path: 'edit', component: EditProfileComponent, canActivate: [PreventLoginAccess]},
  {path: 'verify', component: VerifyComponent},
  {path: 'password', component: PasswordComponent},
  {path: 'forgetpass', component: ForgetPassComponent},
  {path: 'callback', component: CallbackComponent},
  {path: 'pricing', component: PricingComponent},
  {path: 'reminder', component: ReminderComponent, canActivate: [PreventLoginAccess]},
  {path: 'reminder/archives', component: ArchivesComponent},
  {path: 'login_as', component: LoginAsComponent},
  {path: 'p', component: PromptComponentComponent},
  {path: 'payment', component: PaymentComponent},
  {path: 'todo', component: TodolistComponent, canActivate: [PreventLoginAccess]},
  {path: 'charts', component: MyChartComponent, canActivate: [PreventLoginAccess]},
  {path: '404', component: NotFoundComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
